module.exports = __webpack_public_path__ + "img/CB34bs-On-Off-1.a3612428.gif";